var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-tenancy-record-wrapper" }, [
    _c(
      "ul",
      {
        staticClass: "accordion accordion-customize",
        attrs: {
          id: "company-tenancy-record-accordion",
          "data-accordion": "",
          "data-deep-link": "true",
          "data-allow-all-closed": "true",
          "data-mutli-expand": "true",
          "data-update-history": "true",
          "data-deep-link-smudge": "500",
        },
      },
      [
        _c(
          "li",
          {
            staticClass: "accordion-item is-active",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c("a", { staticClass: "accordion-title" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("company.titles.tenancyRecord"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content",
                attrs: { "data-tab-content": "" },
              },
              [
                _c("table", [
                  _c("thead", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("company.tenancyRecord.recordId"))),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("company.contactTable.roleType"))),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("company.tenancyRecord.premises"))),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("company.tenancyRecord.tradeName"))),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$t("company.tenancyRecord.mainContact"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$t("company.tenancyRecord.contactPhone"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.tenancies, function (item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(_vm._s(item.id))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.calcRoleType(item)))]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "a",
                            {
                              staticClass: "link",
                              on: {
                                click: function ($event) {
                                  return _vm.navTo("ccdTenancyView", {
                                    id: item.id,
                                  })
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.premises || "--"))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.tradeName || "--"))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.getMainContactName(item))),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.getMainContactPhone(item))),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.allowCreateTenancy && _vm.showCreateTenancy,
                        expression: "allowCreateTenancy&&showCreateTenancy",
                      },
                    ],
                    staticClass: "btn btn--orange",
                    attrs: { disabled: !_vm.currentCompany.active },
                    on: {
                      click: function ($event) {
                        return _vm.navTo(
                          "ccdTenancyCreate",
                          {},
                          { companyId: _vm.currentCompany.id }
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("company.tenancyRecord.createTenancyRecord")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }